export const essConfig = {
    taxOfficeName: 'ATO'
};
